import { Theme } from "../component/navigation/ThemeDropdown";

export default function MarketIcon({
    isSelected,
    theme,
}: {
    isSelected: boolean;
    theme: Theme;
}) {
    return (
        <div style={{ display: "inline-block", cursor: "pointer" }}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    transition: "fill 0.3s ease",
                }}
            >
                {/* Outer Circle */}
                <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37259 0 0 5.37258 0 12C0 18.6274 5.37259 24 12 24Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Top Shape */}
                <path
                    d="M10.4702 4.0672H16.3389L14.0183 9.56644H18.4275C18.4275 9.56644 11.6091 21.5634 11.4992 21.6947C11.3893 21.826 12.9069 12.4245 12.9069 12.4245H8.47632L10.4672 4.06415L10.4702 4.0672Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Inner Circle */}
                <path
                    d="M9.53894 17.2916C7.21222 17.2916 5.31909 15.3985 5.31909 13.0718C5.31909 10.7451 7.21222 8.85193 9.53894 8.85193C11.8657 8.85193 13.7588 10.7451 13.7588 13.0718C13.7588 15.3985 11.8657 17.2916 9.53894 17.2916Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Inner Circle Border */}
                <path
                    d="M9.53893 9.15421C11.7008 9.15421 13.4534 10.9069 13.4534 13.0687C13.4534 15.2305 11.7008 16.9832 9.53893 16.9832C7.37709 16.9832 5.62442 15.2305 5.62442 13.0687C5.62442 10.9069 7.37709 9.15421 9.53893 9.15421ZM9.53893 8.54352C7.04427 8.54352 5.01373 10.5741 5.01373 13.0687C5.01373 15.5634 7.04427 17.5939 9.53893 17.5939C12.0336 17.5939 14.0641 15.5634 14.0641 13.0687C14.0641 10.5741 12.0336 8.54352 9.53893 8.54352Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Details of the Inner Circle */}
                <path
                    d="M11.1848 14.4794C11.1176 14.6259 11.0229 14.7542 10.9039 14.8611C10.7848 14.9679 10.6382 15.0565 10.4703 15.1236C10.3023 15.1908 10.1161 15.2336 9.90843 15.2488V15.887H9.3466V15.2427C9.06263 15.2091 8.79393 15.1359 8.53744 15.029C8.28095 14.9221 8.04278 14.7786 7.82294 14.6015L8.23514 14.0153C8.4214 14.1649 8.60156 14.287 8.78477 14.3786C8.96492 14.4702 9.16033 14.5343 9.37102 14.5679V13.3038C9.13285 13.2427 8.93133 13.1756 8.75729 13.0962C8.58629 13.0198 8.44278 12.9282 8.32675 12.8214C8.21377 12.7145 8.12827 12.5924 8.07331 12.4549C8.01835 12.3145 7.99087 12.1557 7.99087 11.9756C7.99087 11.7954 8.02446 11.6458 8.08858 11.4992C8.15271 11.3527 8.24431 11.2275 8.36645 11.1175C8.48553 11.0107 8.62904 10.9252 8.79698 10.858C8.96187 10.7939 9.14507 10.7511 9.34965 10.7359V10.3603H9.91149V10.7481C10.1466 10.7786 10.3634 10.8336 10.5588 10.916C10.7542 10.9985 10.9435 11.1053 11.1237 11.2397L10.7634 11.8473C10.4825 11.6366 10.1924 11.4992 9.88705 11.4351V12.6626C10.3787 12.7878 10.7329 12.9527 10.9558 13.1633C11.1787 13.371 11.2886 13.6519 11.2886 14C11.2886 14.1771 11.255 14.3389 11.1878 14.4855L11.1848 14.4794ZM9.37408 11.3893C9.16644 11.4076 9.01378 11.4656 8.90996 11.5664C8.80614 11.6672 8.75423 11.7893 8.75423 11.9298C8.75423 12.0702 8.79392 12.1832 8.87637 12.2748C8.95881 12.3664 9.1237 12.4488 9.37408 12.5221V11.3862V11.3893ZM10.4947 13.8443C10.4764 13.7862 10.4397 13.7313 10.3909 13.6824C10.342 13.6336 10.2748 13.5878 10.1955 13.5481C10.113 13.5084 10.0092 13.4687 9.88705 13.429V14.5985C10.0947 14.5801 10.2504 14.5221 10.3603 14.4244C10.4703 14.3267 10.5252 14.1985 10.5252 14.0427C10.5252 13.9695 10.5161 13.9053 10.4947 13.8473V13.8443Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
            </svg>
        </div>
    );
}
